import React from 'react';
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
} from 'cdbreact';
import { NavLink } from 'react-router-dom';
import './Sidebar.css'

const Sidebar = (props) => {
  return (
    <div className="sidebar">
      <CDBSidebar textColor="#fff" backgroundColor="#333" toggled>
        <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>}>
          <a href="/" className="text-decoration-none" style={{ color: 'inherit' }}>
            CI MANAGER
          </a>
        </CDBSidebarHeader>

        <CDBSidebarContent className="sidebar-content">
          <CDBSidebarMenu>
            <NavLink to="/" className={(navData) => (navData.isActive ? "activeClicked" : 'none')}>
              <CDBSidebarMenuItem icon="columns">Pipelines ({props.running}/{props.total})</CDBSidebarMenuItem>
            </NavLink>
            <NavLink to="/reports" className={(navData) => (navData.isActive ? "activeClicked" : 'none')}>
              <CDBSidebarMenuItem icon="chart-line">Reports</CDBSidebarMenuItem>
            </NavLink>
            <NavLink to="/performance" className={(navData) => (navData.isActive ? "activeClicked" : 'none')}>
              <CDBSidebarMenuItem icon="tachometer-alt">Performance</CDBSidebarMenuItem>
            </NavLink>
          </CDBSidebarMenu>
        </CDBSidebarContent>

        <CDBSidebarFooter style={{ textAlign: 'center' }}>
          <div
            style={{
              padding: '20px 5px',
            }}
          >
            <span className="text-sm">© {new Date().getFullYear()} krasnopv</span>
          </div>
        </CDBSidebarFooter>
      </CDBSidebar>
    </div>
  );
};

export default Sidebar;